// extracted by mini-css-extract-plugin
export default {"font-renta":"ExpensesPage_font-renta__C7aF2","expensesPage":"ExpensesPage_expensesPage__nO5fD","expensesTab":"ExpensesPage_expensesTab__g8KH8"};